import { createSlice } from "@reduxjs/toolkit";

interface initalStateInterface{
  filter: {
    page: number,
    limit: number,
  },
  dropDown: {
    orgUnit:{id:string |number | null ,label:string|number | null},
    employeeStatus:{id:string | number| null,label:string | string |null},
    position:{id:null|number|string, label:string| number | null},
    grade:{id:null|number|string, label:string| number | null},
  },
};

const initialState:initalStateInterface = {
  filter: {
    page: 1,
    limit: 10,
  },
  dropDown: {
    orgUnit:{id: 'null', label: 'All'},
    employeeStatus:{id: null, label: 'All'},
    position:{id: 'null', label: 'All'},
    grade:{id: null, label: 'All'},
  },
};

const employeeSliceModule = createSlice({
  name: "employeeModule",
  initialState,
  reducers: {
    setPage: (state, action) => {
      state.filter.page = action.payload;
    },
    setLimit: (state, action) => {
      state.filter.limit = action.payload;
    },
    setOrgUnit: (state, action) => {
      state.dropDown.orgUnit = action.payload;
    },
        setPosition: (state, action) => {
      state.dropDown.position = action.payload;
    },
     setGrade: (state, action) => {
      state.dropDown.grade = action.payload;
    },
    setEmployeeStatus: (state, action) => {
      state.dropDown.employeeStatus = action.payload;
    },
    setExpenseStatus: (state, action) => {
      state.dropDown.position = action.payload;
    },
    // optional: reset all dropdowns
    resetDropDown: (state) => {
      state.dropDown = {
        orgUnit:{id: 'null', label: 'All'},
        employeeStatus:{id: null, label: 'All'},
        position:{id: 'null', label: 'All'},
        grade:{id: null, label: 'All'},
        };
    },
    resetPagination:(state)=>{
        state.filter={
          page: 1,
          limit: 10,
        }
    }
  },
});

export const {
  setPage,
  setLimit,
  setOrgUnit,
  setPosition,
  setGrade,
  setEmployeeStatus,
  setExpenseStatus,
  resetDropDown,
  resetPagination
} = employeeSliceModule.actions;

export default employeeSliceModule.reducer;
